import { PowerSocketUkIcon } from './PowerSocketUkIcon';

/**
 * author: GreenTurtwig
 * id E9F0AC95-A660-4FB1-BE5D-20153B709E15
 * name power-socket-uk
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power-socket-uk.svg
 * tags
 * - Home Automation 
 */
export const PowerSocketMalaysiaIcon = PowerSocketUkIcon;
export default PowerSocketMalaysiaIcon